import estyled from '@signal/theme/emotion'
import {
  appBarZIndexSelector,
  colorBlackSelector,
  getColorBackgroundSelector
} from '@signal/theme/selectors'
import { getMenuPanelWidth } from '@signal/layouts/utils'
import PureCarsDots from '../PureCarsDots'

export const FooterDots = estyled<{ reversed?: boolean; dotColor?: string }>(
  PureCarsDots
)`
  right: 0;
`

export const PrimaryLink = estyled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};
  cursor: pointer;
`

export const InnerWrapper = estyled.div`
  padding: ${({ theme }) => theme.spacing(2)}px;
  position: relative;
`

export const Wrapper = estyled.footer<{
  hideMenu?: boolean
  mounted?: boolean
  menuPanelWidth?: string
}>`
  border-top: 1px solid ${getColorBackgroundSelector('paper')};
  width: ${({ hideMenu, menuPanelWidth }) =>
    hideMenu
      ? '100%'
      : `calc(100% - ${menuPanelWidth || getMenuPanelWidth()})`};
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: ${appBarZIndexSelector};
  background-color: ${getColorBackgroundSelector('paper')};
  box-sizing: border-box;
  color: ${colorBlackSelector};
  transition: transform 0.5s ease-in 1s, width 0.3s ease-in-out;
  transform: translate(0px, ${({ mounted }) => (mounted ? '0' : '200')}px);
`
